export default "__VITE_ASSET__yrLuDoHU__"